import React from "react"
import "../../components/animations/scroll.scss"
import PropTypes from "prop-types"
import TheaterVideo from "@components/Theater/TheaterVideo"
import { Image, Text } from "../../components/Core"

const StaticHeading = ({ heading, subheading, youtube, language }) => {
  return (
    <div
      style={{
        textAlign: "left"
      }}
      className="static-heading">
      <div
        className="above-text-container"
        style={{ opacity: "1", transition: "unset", textAlign: "left" }}>
        <Text
          role="heading"
          className="curtain-heading h3-style"
          as="h1"
          text={heading}
        />
        <Text
          useStringReplace
          className="above-text__subheader"
          as="span"
          text={subheading}
        />
      </div>

      <div className="homepage__hero-badges">
        <a
          href="https://www.aboms.org/"
          target="_blank"
          aria-label="open link in new tab"
          title="Learn more about the American Board of Oral and Maxillofacial Surgery">
          <Image publicId="BLDR/DEV/aboms-american-board-of-oral-and-maxillofacial-surgery" />
        </a>
        <a
          href="https://www.aaoms.org/"
          target="_blank"
          aria-label="open link in new tab"
          title="Learn more about the American Association of Oral and Maxillofacial Surgeons">
          <Image publicId="BLDR/DEV/aaoms-american-association-oral-and-maxillofacial-surgeons" />
        </a>
      </div>

      {youtube && youtube !== "?" && (
        <TheaterVideo
          videoUrl={`https://www.youtube.com/watch?v=${youtube}`}
          controls
          playing
          onlyButton
          sizzleButton
          buttonClass="sizzle-button-under"
          compId="sizzleTheaterButton"
          language={language}
        />
      )}
    </div>
  )
}

StaticHeading.propTypes = {
  language: PropTypes.string
}

export default StaticHeading
